import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import CloseIcon from '@material-ui/icons/Close';
import PropTypes from 'prop-types';
import styles from './styles';

function DialogHeader(props) {
    const { classes, disableClose, showBackIcon, icon: Icon } = props;
    const shouldShowBack = Boolean(showBackIcon);

    return (
        <AppBar className={classes.appBar} color="primary">
            <Toolbar>
                {!disableClose &&
                    <IconButton color="inherit" onClick={props.handleClose} aria-label="Close">
                        {!shouldShowBack &&
                            <CloseIcon />
                        }
                        {shouldShowBack &&
                            <ArrowBackIcon />
                        }

                    </IconButton>
                }
                {Icon &&
                    <Icon style={{marginRight: 10}} />
                }
                <Typography variant="h6" color="inherit" className={classes.flex} noWrap>
                    {props.title}
                </Typography>
            </Toolbar>
        </AppBar>
    );
}

DialogHeader.propTypes = {
    title: PropTypes.string.isRequired,
    handleClose: PropTypes.func,
    disableClose: PropTypes.bool,
    showBackIcon: PropTypes.bool,
    icon: PropTypes.func
};

export default withStyles(styles)(DialogHeader);